module.exports = __webpack_public_path__ + "static/media/Mobi-Wash.e3587f49.svg";